import type { Theme } from "@mui/material/styles";

export const DOT_SIZE = 18;

export const MOBILE_DOT_SIZE = 13;

export const DOT_HALO = 3;

export const LINE_OPACITY = 0.35;

export const MIN_GAP_PERCENT = 3;

export const MOBILE_MIN_GAP_PERCENT = 7;

export const TOOLTIP_MAX_WIDTH = 280;

export const TOOLTIP_PADDING_X = 12;

export const TOOLTIP_SLIDER_WIDTH = TOOLTIP_MAX_WIDTH - 2 * TOOLTIP_PADDING_X;

/** Grace period for the pointer to travel from a badge into its tooltip. */
export const CURSOR_LEAVE_DELAY_MS = 80;

export const getTooltipSurface = (theme: Theme) =>
  theme.palette.mode === "dark"
    ? { surface: "#FFFFFF", onSurface: "#14151A" }
    : { surface: "#14151A", onSurface: "#FFFFFF" };
